<template>
  <div class="ticketListCon">
    <div class="orderBox">
      <ul>
        <li v-for="item in orderList" :key="item.key" @click="orderClick(item)" :class="{'unselect' : item.key !== order, 'down': item.ascending}">
          {{ item.value }}
        </li>
      </ul>
    </div>
    <v-data-table
    :headers="headers"
    :items="datas"
    v-model="selected"
    class="UXdatatables"
    :class="{'tblHover': datas.length}"
    hide-actions
    select-all>
    <template slot="headers" slot-scope="props">
      <tr>
        <th style="width:35px;">
          <v-checkbox
            :input-value="props.all"
            @click.native="toggleAll"
            class="UXcheckbox gray"
            hide-details
          ></v-checkbox>
        </th>
        <th v-for="header in headers" :key="header.text" :style="{width: header.width + 'px'}" v-if="header.text !== 'サービス名' || callMode === 'KT'">
          {{ header.text }}
        </th>
<!--        <th @click="openHeaderCustomizeDialog" class="checkbox-wid cursor">-->
<!--          <v-tooltip bottom>-->
<!--            <template v-slot:activator="{ on }">-->
<!--              <i class="fas fa-plus-circle blue-grey&#45;&#45;text fs-20 mt-1" v-on="on"></i>-->
<!--            </template>-->
<!--            <span>테이블 헤더를 자유롭게 편집 할 수 있습니다.</span>-->
<!--          </v-tooltip>-->
<!--        </th>-->
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr :active="props.selected" class="cursor">
        <td>
          <v-checkbox
            v-model="props.selected"
            class="UXcheckbox gray"
            hide-details
          ></v-checkbox>
        </td>
        <td @click="ticketRowClicked(props.item.dispId)">{{ TicketIncomingChannel[props.item.ticketIncomingChannel] }}</td>
        <td @click="ticketRowClicked(props.item.dispId)" :class="{corRed: prioritys[props.item.priority] === '緊急'}">{{ prioritys[props.item.priority] }}</td>
        <td @click="ticketRowClicked(props.item.dispId)">{{ ticketStatus[props.item.status] }}</td>
        <td @click="ticketRowClicked(props.item.dispId)" class="thList">
          <ul>
            <li>{{ props.item.dispId }}</li>
            <li class="tit clampTxt line-clamp-1">{{ props.item.subject }}</li>
            <li class="path">
              <span v-for="(t, index) in props.item.taskTypes" :key="index">
                {{ t.taskName }}
              </span>
              <span v-if="!props.item.taskTypes.length">-</span>
            </li>
          </ul>
        </td>
        <td @click="ticketRowClicked(props.item.dispId)" class="service" v-if="callMode === 'KT'">
          <div v-if="props.item.serviceName && props.item.serviceNumber">
            <span>{{ props.item.serviceName}}</span><br/>
            <span class="normalFW">{{ props.item.serviceNumber}}</span>
          </div>
          <div v-else>-</div>
        </td>
        <td @click="ticketRowClicked(props.item.dispId)" class="ticketListCustomer">
          <span style="font-weight: bold;">{{ props.item.customerName || '-' }}</span><br />{{ props.item.customerPhone || '-' }}
        </td>
        <td @click="ticketRowClicked(props.item.dispId)" class="name">
          <p><span class="clampTxt line-clamp-1">{{ props.item.agentName || '-' }}</span></p>
        </td>
        <td @click="ticketRowClicked(props.item.dispId)" class="date">
          {{ props.item.createDate.split(' ')[0] }}<br/>
          <span>{{ props.item.createDate.split(' ')[1] }}</span>
        </td>
        <td @click="ticketRowClicked(props.item.dispId)" class="date">
          {{ props.item.modifyDate.split(' ')[0] }}<br/>
          <span>{{ props.item.modifyDate.split(' ')[1] }}</span>
        </td>
        <td @click="ticketRowClicked(props.item.dispId)" class="memo">
          <div class="clampTxt" style="max-width:100%">
            {{ props.item.memo || '-' }}
          </div>
        </td>
        <td @click="ticketRowClicked(props.item.dispId)" class="tags">
          <div v-if="!props.item.tags">-</div>
          <div v-else class="tagsList inlineFlex">
            <p v-for="(name, index) in props.item.tags.split(',')" :key="index"><span class="clampTxt line-clamp-1">{{name}}</span></p>
          </div>
        </td>
      </tr>
    </template>
    <template v-slot:no-data>
      <div v-if="errorCode === 0" class="UXnotData large" style="height:370px;">照会結果がありません。</div>
      <div v-if="errorCode === -500" style="height:370px;">
        <div class="UXrefresh" style="height:370px;">
          チケットの照会が遅れています。<br />
          しばらくしてからもう一度お試しください。<br />
          <v-btn outline round large class="UXbtn" style="min-width:80px;" @click="$emit('input')" :disabled="!isTicketRefresh">更新</v-btn>
        </div>
      </div>
    </template>
  </v-data-table>
    <pagination
      v-model="pagination.page"
      :length="pagination.totalPages"
      @input="paginationClick"
    ></pagination>
  </div>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import Tooltip from '@/components/tooltip'
import eventBus from '@/event_bus'
import event from '../../../enums/eventType'
import helper from '@/util/helpers'
import {mapGetters} from 'vuex'

export default {
  props: {
    excelDownloading: Boolean,
    headers: Array,
    datas: Array,
    isTicketRefresh: Boolean,
    errorCode: Number,
    pagination: JSON,
    changePage: Function,
    onCheckBoxChanged: Function,
    onPageSizeChanged: Function,
    order: String,
    ascending: Boolean,
    updateTicketListOption: Function
  },
  components: {
    Tooltip
  },
  data: () => ({
    tipDialog: false,
    selected: [],
    mergedList: [],
    prioritys: {
      LOW: '低い',
      NORMAL: '普通',
      HIGH: '高い',
      EMERGENCY: '緊急'
    },
    ticketStatus: {
      ACTIVE: '有効',
      PENDING: '保留',
      INACTIVE: '無効',
      RESOLVED: '解決'
    },
    TicketIncomingChannel: {
      MEMO: 'メモ',
      CALL: '電話',
      TALK: 'チャット',
      CHAT_BOT: 'チャットボット',
      MESSAGE: 'メッセージ',
      MAIL: 'メール',
      SURVEY: 'アンケート'
    }
  }),
  computed: {
    ...mapGetters([
      'callMode'
    ]),
    orderList () {
      return [
        {key: 'modifyDate', value: '更新日時', ascending: false},
        {key: 'createDate', value: '受付日時', ascending: false},
        {key: 'dispId', value: 'ID', ascending: false},
        {key: 'priority', value: '優先順位', ascending: false}
      ]
    }
  },
  watch: {
    selected: {
      handler: function () {
        this.onCheckBoxChanged(this.selected)
      },
      deep: true
    },
    order: {
      handler: function () {
        this.setOrder()
      },
      immediate: true
    }
  },
  methods: {
    setOrder () {
      this.orderList.forEach(o => {
        if (o.key === this.order) {
          o.ascending = this.ascending
        }
      })
    },
    parseTicketData (data, type) {
      return TicketListUtil.parseTicketEnumIntoString(data, type)
    },
    ticketColumnStyle (data, type) {
      let text = TicketListUtil.parseTicketEnumIntoString(data, type)
      return TicketListUtil.getStyleFromTypeText(type, text)
    },
    paginationClick (page) {
      this.pagination.page = page
      this.changePage(page)
    },
    toggleAll () {
      if (this.selected.length === this.datas.slice().length) {
        this.selected = []
      } else {
        this.selected = this.datas.slice()
      }
    },
    // TODO 티켓 눌렀을때 상호작용 - Api 아니면 front
    ticketRowClicked (dispId) {
      const displayId = dispId.replace('#', '')
      /* Domain에 따라서 DetailPage 분기: Gnb 이슈 */
      let url = this.$route.path === '/ticket/list' ? '/ticket/list/ticket_details' : '/ticket/ticket_details'
      this.$router.push(url + '?displayId=' + displayId)
    },
    openHeaderCustomizeDialog () {
      eventBus.$emit(event.OPEN_TICKET_LIST_HEADER_CUSTOMIZE_DIALOG)
    },
    resetSelected () {
      this.selected = []
    },
    checkCustomerNameLength (customerName) {
      return customerName.length > 7
    },
    reduceCustomerName (customerName) {
      return helper.reduceText(customerName, 7)
    },
    orderClick (item) {
      item.ascending = item.key === this.order ? !item.ascending : item.ascending
      this.pagination.page = 1
      this.changePage(1, true, item.key, item.ascending)
      this.updateTicketListOption('order', item.key)
      this.updateTicketListOption('ascending', item.ascending)
    }
  }
}
</script>

<style lang="scss">
  .ticketListCustomer {
    font-size:14pt;
    vertical-align: center;
    line-height: 20px;
  }
  .ticketListCon {
    .orderBox{
      position: absolute;
      top:10px;
      left: 90px;
      ul {
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 50px;
        li {
          list-style: none;
          margin-right: 5px;
          padding-right: 22px;
          position: relative;
          color: $gray-9;
          cursor: pointer;
          opacity: 1;
          &:after {
            content: "\e960";
            position: absolute;
            top:-6px;
            right:0;
            font-size:22px;
            font-family: 'twc' !important;
            transform: rotate(0);
            -webkit-transform:  rotate(0);
          }
          &.down {
            &:after {
              transform: rotate(180deg);
              -webkit-transform: rotate(180deg);
            }
          }
          &.unselect {
            color: $gray-6;
            /*opacity: 0.3;*/
            /*&:after {*/
            /*  transform: rotate(180deg);*/
            /*  -webkit-transform: rotate(180deg);*/
            /*}*/
          }
        }
      }
    }
    .UXdatatables {
      .v-datatable {
        tbody {
          tr {
            td {
              padding: 15px 0;
              height:100px;
              text-align: center;
              .clampTxt {
                text-align: center;
              }
              &.thList {
                padding-left:20px;
                text-align: left;
                ul {
                  padding:0;
                  li {
                    list-style: none;
                    font-size: 14px;
                    color: $gray-7;
                    line-height:22px;
                    &.tit {
                      font-size: 16px;
                      max-width: 100%;
                      color: $gray-8;
                      font-weight: bold;
                      &.clampTxt {
                        text-align: left;
                      }
                    }
                    &.path {
                      span {
                        position:relative;
                        padding-left:10px;
                        &:before {
                          content: '>';
                          position: absolute;
                          top:-2px;
                          left:0;
                        }
                        &:first-child {
                          padding-left:0;
                          &:before {
                            display:none;
                          }
                        }
                      }
                    }
                    &.date {
                      width: 100%;
                      display:table;
                      font-size: 12px;
                      p {
                        margin: 0;
                        float:left;
                        span {
                          color: $gray-8;
                        }
                      }
                    }
                  }
                }
              }
              &.tags {
                .tagsList {
                  text-align: left;
                  p {
                    margin: 0;
                    padding:0 5px 5px 0;
                    display: inline-block;
                    span {
                      padding: 3px 10px 3px 10px;
                      color: #414141;
                      line-height: 20px;
                      background: #E8E8E8;
                      border-radius: 16px;
                      max-width: max-content;
                      word-break: break-all;
                    }
                  }
                }
              }
              &.memo {
                .clampTxt {
                  max-height:64px;
                }
              }
              &.corRed {
                color: #FF0000;
              }
              &.name {
                p {
                  margin:0;
                  font-size: 12px;
                  line-height:18px;
                  &:last-child {
                    margin-top:8px;
                    color: $gray-6;
                  }
                  span {
                    font-size: 14px;
                    color: $gray-8;
                  }
                }
              }
              &.date {
                line-height:18px;
                span {
                  color:$gray-6;
                }
              }
              &.service {
                font-weight: bold;
                .normalFW {
                  font-weight: normal;
                }
              }
            }
          }
        }
      }
    }
  }
  .checkbox-wid{
    width: 15px !important;
    text-align: center !important;
  }
</style>

<style lang="scss" scoped>
.ticketListCon {
  .UXdatatables {
    /deep/ .v-datatable tbody tr td {
      padding: 15px 5px;
    }
  }
  .UXrefresh {
    padding-top: 186px;
    &::before {
      top: 107px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_show_list.vue